import React, { useRef } from 'react';
import { useTooltip } from "../../../Tooltip";
import { onMouseEnterHandlerDecorator, TooltipText } from "../../../Grid/cellRenderers/helpers";
import { TEXT_SIZE } from "../../../Text";
import { styles } from './styles';
import { cn } from "../../../helpers";
import { SORT_DIRECTION } from '@veeam/core';
import { DirectionIcon } from "./DirectionIcon";
import { COLUMN_CONTENT_JUSTIFY } from "../../GridCore.public";
var SortIndicator = React.memo(function (_a) {
    var direction = _a.direction;
    return (React.createElement("div", { className: cn(styles.sortIcon, direction === SORT_DIRECTION.desc && styles.rotateIcon) },
        React.createElement(DirectionIcon, null)));
});
export var GridHeaderCell = React.memo(function GridTextCell(props) {
    var ref = useRef(null);
    return useTooltip({
        delayTimeout: 500,
        maxWidth: (props.tooltipMaxWidth || props.columnWidth + 50) + "px",
        renderContent: function () { return React.createElement(TooltipText, { size: TEXT_SIZE.s }, props.text); },
        render: function (tooltipProps) {
            var clickable = !!props.onClick;
            return (React.createElement("div", { className: cn(styles.root, clickable && styles.clickable, props.className, props.justify === COLUMN_CONTENT_JUSTIFY.end && styles.justifyEnd), onClick: props.onClick, onMouseDown: props.onMouseDown },
                React.createElement("div", { ref: ref, className: cn(styles.text), onMouseEnter: onMouseEnterHandlerDecorator(tooltipProps.onMouseEnter, ref), onMouseLeave: tooltipProps.onMouseLeave }, props.text),
                props.sorting && React.createElement(SortIndicator, { direction: props.sorting })));
        }
    });
});
//# sourceMappingURL=GridHeaderCell.js.map